export const appendToUrl = (url, path) => {
    url = url.endsWith('/') ? url : `${url}/`;
    if (path.startsWith('/'))
        return `${url}${path.slice(1)}`;
    return `${url}${path}`;
};
export const assertValidUrl = (url) => {
    try {
        void new URL(url);
    }
    catch {
        throw new Error('baseUrl is not a valid URL');
    }
};
export const normalizeHeaders = (headers) => {
    if (headers instanceof Headers || Array.isArray(headers)) {
        return Object.fromEntries(headers);
    }
    return headers;
};
export const omitUndefined = (obj) => Object.fromEntries(Object.entries(obj).filter(([, value]) => value !== undefined));
export const defaultRetryableStatusCodes = [
    408, // Request Timeout
    425, // Too Early
    429, // Too Many Requests
    503, // Service Unavailable
    504, // Gateway Timeout
];
export const defaultRetryBackoff = ({ attempt }) => {
    return Math.max(400 * 2 ** attempt, 1600);
};
export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
export class HttpError extends Error {
    response;
    constructor(message, response) {
        super(message);
        this.response = response;
    }
}
